import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpClientType } from '../studio-http-client/http-client-type';
import { environment } from '../../../environments/environment';
import { TokenService } from '../services/token.service';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const clientTypeExists = req.headers.get('clientType');

  // If clientType doesn't exist then send the request as it is
  if (!clientTypeExists) {
    return next(req);
  }

  // Remove clientType header as it was only used here to determine which client auth token required here
  let headers = req.headers.delete('clientType');

  const authToken = inject(TokenService).getAuthToken();

  let newReq = req;

  const clientType = +clientTypeExists as HttpClientType;

  if (clientType === HttpClientType.Identity) {
    if (authToken.idToken) {
      headers = headers.append('Authorization', `bearer ${authToken.idToken}`);
    }
    newReq = req.clone({
      url: `${environment.idsApiUrl}${req.url}`,
      headers,
    });
  } else if (clientType === HttpClientType.LightSail) {
    if (authToken.lsToken) {
      headers = headers.append('Authorization', `bearer ${authToken.lsToken}`);
    }
    if (authToken.lsShardKey) {
      headers = headers.append('ShardKey', authToken.lsShardKey);
    }
    newReq = req.clone({
      url: `${environment.lsApiUrl}${req.url}`,
      headers,
    });
  } else if (clientType === HttpClientType.MindPlay) {
    if (authToken.mpToken) {
      headers = headers.append('Authorization', `bearer ${authToken.mpToken}`);
    }
    newReq = req.clone({
      url: `${environment.mpApiUrl}${req.url}`,
      headers,
    });
  } else if (clientType === HttpClientType.Fluency) {
    if (authToken.fluencyToken) {
      headers = headers.append('Authorization', `bearer ${authToken.fluencyToken}`);
    }
    newReq = req.clone({
      url: `${environment.fluencyApiUrl}${req.url}`,
      headers,
    });
  } else if (clientType === HttpClientType.Screener) {
    if (authToken.screenerToken) {
      headers = headers.append('Authorization', `bearer ${authToken.screenerToken}`);
    }
    newReq = req.clone({
      url: `${environment.screenerApiUrl}${req.url}`,
      headers,
    });
  }
  return next(newReq);
}
